import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { FacetFilterComponent } from './facet-filter.component'
import { ReactiveFormsModule } from '@angular/forms'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { OldSvgModule } from '../../_deprecated/svg/old-svg.module'

@NgModule({
  imports: [CommonModule, RouterModule, ReactiveFormsModule, OldSvgModule, AnalyticsModule],
  declarations: [FacetFilterComponent],
  exports: [FacetFilterComponent]
})
export class FacetFilterModule {}
